import createIcon from '../../createIcon';

/**
 * @component @name AirlineSeatLegroomReduced
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuNDcxIDE5LjJDMjAuNjUxIDIwLjE2IDE5LjkyMSAyMSAxOS4wMDEgMjFIMTQuNTAxVjE4TDE1LjUwMSAxNEg5LjUwMDk4QzcuODUwOTggMTQgNi41MDA5OCAxMi42NSA2LjUwMDk4IDExVjNIMTIuNTAxVjlIMTcuNTAxQzE4LjYwMSA5IDE5LjUwMSA5LjkgMTkuNTAxIDExTDE3LjUwMSAxOEgxOC45NDFDMTkuNjcxIDE4IDIwLjMzMSAxOC40OSAyMC40NzEgMTkuMlpNNS41MDA5OCAxMlYzSDMuNTAwOThWMTJDMy41MDA5OCAxNC43NiA1Ljc0MDk4IDE3IDguNTAwOTggMTdIMTIuNTAxVjE1SDguNTAwOThDNi44NDA5OCAxNSA1LjUwMDk4IDEzLjY2IDUuNTAwOTggMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AirlineSeatLegroomReduced = createIcon('AirlineSeatLegroomReduced', [
  [
    'path',
    {
      d: 'M20.471 19.2C20.651 20.16 19.921 21 19.001 21H14.501V18L15.501 14H9.50098C7.85098 14 6.50098 12.65 6.50098 11V3H12.501V9H17.501C18.601 9 19.501 9.9 19.501 11L17.501 18H18.941C19.671 18 20.331 18.49 20.471 19.2ZM5.50098 12V3H3.50098V12C3.50098 14.76 5.74098 17 8.50098 17H12.501V15H8.50098C6.84098 15 5.50098 13.66 5.50098 12Z',
      key: '1fryk9',
    },
  ],
]);

export default AirlineSeatLegroomReduced;
